import EnglishIcon from "./../assets/svg/english.svg";
import CalendarIcon from "./../assets/svg/calendar.svg";
import CreativityIcon from "./../assets/svg/creativity.svg";
import OrderIcon from "./../assets/svg/order.svg";
import FacebookIcon from "./../assets/svg/facebook_author.svg";
import WWWIcon from "./../assets/svg/www_author.svg";
import MonikaJPG from "./../assets/img/authors/Monika.jpg";
import AniaJPG from "./../assets/img/authors/Anna.jpg";
import MarlenaJPG from "./../assets/img/authors/Marlena.jpg";
import AgnieszkaJPG from "./../assets/img/authors/Agnieszka.jpg";
import RenataJPG from "./../assets/img/authors/Renata.jpg";
import KarolinaJPG from "./../assets/img/authors/Karolina.jpg";
import one from "./../assets/img/planner_bowel/01.png";
import two from "./../assets/img/planner_bowel/02.png";
import three from "./../assets/img/planner_bowel/03.png";
import four from "./../assets/img/planner_bowel/04.png";
import five from "./../assets/img/planner_bowel/05.png";
import six from "./../assets/img/planner_bowel/06.png";
import seven from "./../assets/img/planner_bowel/07.png";
import eight from "./../assets/img/planner_bowel/08.png";

export const boxesENG = [
    {
        header: "Teaching English as a foreign language",
        description:
            "Created especially for English teachers of young learners",
        icon: EnglishIcon,
    },
    {
        header: "School Year 2021/2022",
        description:
            "… or actually even more! August 2021 – August 2022 planner with 13 months of monthly and weekly pages.",
        icon: CalendarIcon,
    },
    {
        header: "Boost of creativity",
        description:
            "Content pages with ideas for English lessons in preschool and early school education  ",
        icon: CreativityIcon,
    },
    {
        header: "Organiser",
        description: "All in one – calendar and teacher’s planner",
        icon: OrderIcon,
    },
];

export const situationsENG = [
    {
        header: "You need to think over and plan effective lessons and you would appreciate a thoughtful monthly schedules of themes and materials.",
        description:
            "It’s easy now! You will find ready to use monthly calendar themes inside the GC planner. Lesson planning spreads also contain lesson objectives, suggested songs, basic vocabulary and expressions lists, extended vocabulary lists, suggested games and activities around the topic.",
        inverted: false,
    },
    {
        header: "Again! It’s Sunday and you start your weekly preparations. Some surprising ideas for your lessons would be invaluable.",
        description:
            "Simply, just have a look inside your GC planner and dive into a multitude of teaching hacks, suggested games and plays. You really just need to read and go!",
        inverted: true,
    },
    {
        header: "You are looking for catchy nursery rhymes.",
        description:
            "Check the GC planner and you will definitely find them there.",
        inverted: true,
    },
    {
        header: "You consider yourself a creative teacher but this time you are either short of time or you don’t feel like making up new games for your next lesson.",
        description:
            "Great! Browse through the GC planner and pick one of described ideas. There are games & plays offered for each and every week included in the planner.",
        inverted: false,
    },
    {
        header: "You need to look up some dates and theme days.",
        description:
            "We prepared lists of holidays, special dates and unusual theme days every month. Theme days sound a good opportunity to create an attractive lesson.",
        inverted: false,
    },
    {
        header: "You teach several groups of children and have attendance lists, grades, lesson schedules or contacts scattered in a few notebooks. And you carry them all with you each day.",
        description:
            "Oh, we know that you like shopper bags, but save some room for carrying extra teaching aids instead of pushing inside a few planners or notebooks. Just grab your all-in-one GC planner and it will do.",
        inverted: true,
    },
    {
        header: "You use two or more calendars to hold both your professional and private notes.",
        description:
            "No more! You can hold all of them in GC planner. It is veeery capacious.",
        inverted: false,
    },
];

export const detailsBoxesENG = [
    {
        header: "School Year Calendar",
        description:
            "Planner with 13 months of monthly and weekly pages from August 2021 to August 2022",
    },
    {
        header: "Let’s plan",
        description:
            "Ready to use lesson planning spreads which cover all school year. There is some additional space for you own notes",
    },
    {
        header: "My students",
        description:
            "Useful tables to gather information about your students and groups, such as attendance, grades, homework completion and more  (10 table spreads for 10 groups of students)",
    },
    {
        header: "Contacts",
        description:
            "Your handy contact lists to organise phone numbers, addresses etc.",
    },
    {
        header: "Teaching hacks  -  tips useful in your everyday work",
        sublist: [
            { item: "5 reliable energisers for your lessons" },
            { item: "5 Various speaking incentives" },
            {
                item: "5 Mindfulness exercises which support learning a foreign language",
            },
            {
                item: "6 Beginner’s tips – useful time-savers and other tricks",
            },
            {
                item: "TOP 10 BOOKS – a list of must-have English books for children which guarantee a wow effect on your lessons",
            },
            {
                item: "TOP 5 SITES – a list od educational sites for children. Use them to make your lessons more attractive and interactive",
            },
            {
                item: "Lists of interesting English films and series for children",
            },
        ],
    },
    {
        header: "Filled-in monthly theme schedules",
        description:
            "Iincluding lesson objectives, suggested songs, basic vocabulary and expressions lists, extended vocabulary lists, suggested games and activities around the topic (60 ideas!)",
    },
    {
        header: "Nursery rhymes",
        description: "20 theme rhymes adored by young learners",
    },
    {
        header: "Creativity",
        description:
            "Games and activities suggested every week (58 ideas ready to use)",
    },
    {
        header: "Let’s celebrate",
        description:
            "Lists of official holidays, special dates and theme days every month",
    },
    {
        header: "Weekly view pages",
        description:
            "Which offer ample writing space for detailed daily planning and classroom scheduling every day of the week so you can stay organized throughout the school year",
    },
    {
        header: "Ready-to-use craft",
        description:
            "Additional pages with a calendar to cut out and colour with your children; use it to revise months or seasons of the year",
    },
    { header: "Notes", description: "Ample space for your notes" },
];

export const slidesENG = [
    {
        title: "School Year Calendar",
        description:
            "Planner with 13 months of monthly and weekly pages from August 2021 to August 2022",
        photo: one,
    },
    {
        title: "Let’s plan",
        description:
            "Ready to use lesson planning spreads which cover all school year",
        photo: two,
    },
    {
        title: "My students",
        description:
            "Useful tables to gather information about your students and groups, such as attendance, grades, homework completion and more ",
        photo: three,
    },
    {
        title: "Teaching hacks, Nursery rhymes, Let’s celebrate",
        list: [
            { item: "Tips useful in your everyday work" },
            { item: "20 theme rhymes adored by young learners" },
            {
                item: "Lists of official holidays, special dates and theme days",
            },
        ],
        photo: four,
    },
    {
        title: "Filled-in monthly theme schedules",
        description:
            "Including lesson objectives, suggested songs, basic vocabulary and expressions lists, extended vocabulary lists, suggested games and activities around the topic (60 ideas!)",
        photo: five,
    },
    {
        title: "Weekly view pages",
        description:
            "They offer ample writing space for detailed daily planning and classroom scheduling every day of the week. Creative games and activities suggested every week (58 ideas ready to use)",
        photo: six,
    },
    { title: "Notes", description: "Ample space for your notes", photo: seven },
    {
        title: "Ready-to-use craft",
        description:
            "Additional pages with a calendar to cut out and colour with your children",
        photo: eight,
    },
];

export const buyHeadersENG = [
    {
        header: "You see?",
        description:
            "Get Creative Every Day is not only a calendar or planner, this is an essential teacher’s kit full of valuable materials for your English lessons around the year!",
    },
    {
        header: "Should you buy it now or wait until a new school year starts?",
        description:
            "We advise you not to postpone your decision as our stock is running out quickly and we usually do not reprint it. Don’t waste your holiday time to prepare your schedules for the following year. Enter the new school year at ease with your own copy of GC planner!",
    },
];

export const authorsENG = [
    {
        photo: MonikaJPG,
        links: [
            {
                link: "get-creative-everyday-demo.netlify.app",
                icon: FacebookIcon,
            },
            {
                link: "get-creative-everyday-demo.netlify.app",
                icon: WWWIcon,
            },
        ],
        author: {
            name: "Anna Kowalska",
            description:
                "English teacher with 18 years of experience in Poland, England and Ireland, director of studies and teacher trainer. Supports didactic teams in language schools, trains teachers and speaks at conferences and branch meetings. Author of the website That is Evil addressed to EFL teachers.",
        },
    },
    {
        photo: AniaJPG,
        links: [
            {
                link: "get-creative-everyday-demo.netlify.app",
                icon: FacebookIcon,
            },
            {
                link: "get-creative-everyday-demo.netlify.app",
                icon: WWWIcon,
            },
        ],
        author: {
            name: "Martyna Bornicka",
            description:
                "English teacher in kindergarten. A keen lover of books for children, for whom storytelling is a favorite element of the classes. Founder of Little Forest Children's Bookshop, a place full of creative teaching aids for teachers.",
        },
    },
    {
        photo: MarlenaJPG,
        links: [
            {
                link: "get-creative-everyday-demo.netlify.app",
                icon: FacebookIcon,
            },
            {
                link: "get-creative-everyday-demo.netlify.app",
                icon: WWWIcon,
            },
        ],
        author: {
            name: "Cristine John",
            description:
                "English teacher for over 9 years. Author of the english blog. Her philosophy for education has always been to make learning exciting, interesting and fun.",
        },
    },
    {
        photo: KarolinaJPG,
        links: [
            {
                link: "get-creative-everyday-demo.netlify.app",
                icon: FacebookIcon,
            },
            {
                link: "get-creative-everyday-demo.netlify.app",
                icon: WWWIcon,
            },
        ],
        author: {
            name: "Karolina Machnicka",
            description:
                "An English teacher who loves working with children. She often uses unusual teaching aids and English-language books in her lessons. On a daily basis, she shares her ideas and provides materials in the blog.",
        },
    },
    {
        photo: RenataJPG,
        links: [
            {
                link: "get-creative-everyday-demo.netlify.app",
                icon: FacebookIcon,
            },
            {
                link: "get-creative-everyday-demo.netlify.app",
                icon: WWWIcon,
            },
        ],
        author: {
            name: "Renata Nowak",
            description:
                "MA in English Philology, a teacher with over 10 years of experience. Author of the blog 'EasyPeasy' and the guide 'English without a Handbook'. Methodological consultant who supported the creation of an educational robot at Dino University.",
        },
    },
    {
        photo: AgnieszkaJPG,
        links: [
            {
                link: "get-creative-everyday-demo.netlify.app",
                icon: FacebookIcon,
            },
            {
                link: "get-creative-everyday-demo.netlify.app",
                icon: WWWIcon,
            },
        ],
        author: {
            name: "Agnieszka Roland",
            description:
                "She creates language games that she would like to play, prepares lessons in which she would like to participate, teaches in the way she would like to be taught. She helps other teachers to make language classes more attractive and lively. She creates original games, which she willingly shares with teachers of various languages on the website. She shows how to use technology in the classroom and teaches others how to teach in order to have fun in one’s own lessons. She makes both teachers and students want to learn.",
        },
    },
];
